import Cookies from 'js-cookie'

import apiWallet from '@/api/wallet'
import { setLastSync, getLastSync } from '@/utils/sync'

const userInfoKey = 'User-Info'

const defaultState = {
  timesync: '',
  profile: {},
  bankAccount: {},
  wallet: {},
  slots: {},
  slotAccount: [],
  sportAccount: [],
  lottoAccount: [],
  total: 0,
  inviteAmount: 0,
  inviteSuccess: 0,
  inviteFail: 0
}

const initialState = localStorage.getItem(userInfoKey)
  ? JSON.parse(localStorage.getItem(userInfoKey)) || defaultState
  : defaultState

const actions = {
  clearUserInfo({ commit }) {
    commit('clearUserInfoState')
  },
  updateTimeSync({ commit }) {
    commit('commitUpdateTimeSync')
  },
  async getUserWallet({ commit }) {
    let userInfoValue = {}
    try {
      const data = await apiWallet.getUserWallet()
      userInfoValue.profile = data.profile
      userInfoValue.bankAccount = data.bankAccount
      userInfoValue.wallet = data.wallet
      userInfoValue.inviteAmount = data.invite.amount
      userInfoValue.inviteSuccess = data.invite.success
      userInfoValue.inviteFail = data.invite.fail
      userInfoValue.total = userInfoValue.wallet.amount
      userInfoValue.slots = data.slots

      userInfoValue.slotAccount = []
      userInfoValue.sportAccount = []
      userInfoValue.lottoAccount = []
      data.slots.forEach(slot => {
        if (slot.category === 'slot') {
          userInfoValue.slotAccount.push(slot)
        } else if (slot.category === 'sport') {
          userInfoValue.sportAccount.push(slot)
        } else if (slot.category === 'lotto') {
          userInfoValue.lottoAccount.push(slot)
        }
        userInfoValue.total += slot.amount
      })
      setLastSync()
      userInfoValue.timesync = getLastSync()
      Cookies.set('userInfoKey', userInfoValue)
      commit('setUseInfo', userInfoValue)
    } catch (error) {
      console.log(error)
    }
  }
}

const mutations = {
  setUseInfo(state, userInfoValue) {
    Object.assign(state, userInfoValue)
    localStorage.setItem(userInfoKey, JSON.stringify(userInfoValue))
  },
  commitUpdateTimeSync(state) {
    setLastSync()
    Object.assign(state, { ...state, timesync: getLastSync() })
  },
  clearUserInfoState(state) {
    Object.assign(state, {})
    localStorage.removeItem(userInfoKey)
  }
}
export const userInfo = {
  namespaced: true,
  state: initialState,
  actions,
  mutations
}
